// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'DELETE',
    endpoint: '/api/assistenza/ticket/:id',
    requestBody: null,
    response: '{ success: true }'
  },
  {
    method: 'GET',
    endpoint: '/api/assistenza/ticket/:id',
    requestBody: null,
    response: '{ success: true, data: { id, tipo, priorita, stato, titolo, descrizione, modulo, urlPagina, createdById, createdByName, createdAt, updatedAt, chiusoAt, societa: { id, nome }, allegati: [{ id, nomeFile, mimeType, dimensione, uploadedAt }], risposte: [{ id, utenteId, utenteName, testo, isStaff, createdAt }], chat: { id, stato, documentiKb, messaggi: [{ id, ruolo, testo, allegati: [{ nomeFile, mimeType, dimensione }] | null, createdAt }] } | null } }'
  },
  {
    method: 'PUT',
    endpoint: '/api/assistenza/ticket/:id',
    requestBody: '{ stato?, priorita? }',
    response: '{ success: true }'
  },
  {
    method: 'POST',
    endpoint: '/api/assistenza/ticket/:id/risposte',
    requestBody: '{ testo }',
    response: '{ success: true, data: { id } }'
  },
  {
    method: 'POST',
    endpoint: '/api/assistenza/ticket/:id/conferma-chiusura',
    requestBody: null,
    response: '{ success: true }'
  },
  {
    method: 'POST',
    endpoint: '/api/assistenza/ticket/:id/riapri',
    requestBody: '{ motivo }',
    response: '{ success: true }'
  },
  {
    method: 'GET',
    endpoint: '/api/assistenza/ticket/:id/allegati/:allegatoId/download',
    requestBody: null,
    response: '(file stream)'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
